import React from "react";
import { SourceChip } from "./SourceChips";

// Inline <LinkPreview> tags in model output render as the same compact
// source chip used in the sources footer.
const LinkPreview = ({ url }) => <SourceChip url={url} />;

export default LinkPreview;
